export const shopifyDiscountsCopy = {
  heading: 'Store discounts',
  description:
    'Codes Discovr created for your creators, and the other discounts in your Shopify store. Read-only here.',
  openInShopify: 'Open in Shopify',
  viewInShopify: 'View in Shopify',
  newTab: '(opens in a new tab)',
  views: {
    ariaLabel: 'Discount source',
    discovr: 'Discovr codes',
    other: 'Other discounts',
  },
  columns: {
    title: 'Discount name',
    code: 'Code',
    creator: 'Creator',
    campaign: 'Campaign',
    discount: 'Discount',
    codes: 'Code(s)',
    type: 'Type / Value',
    status: 'Status',
    uses: 'Uses',
    dates: 'Dates',
    actions: 'Actions',
  },
  status: { ACTIVE: 'Active', SCHEDULED: 'Scheduled', EXPIRED: 'Expired' },
  automatic: 'Automatic',
  untitledCampaign: 'Untitled campaign',
  noValue: '-',
  moreCodes: (shown: number, total: number) => `+${total - shown} more`,
  dates: (start: string | null, end: string | null) => {
    if (start && end) return `${start} - ${end}`;
    if (start) return `From ${start}`;
    if (end) return `Until ${end}`;
    return '-';
  },
  filters: {
    searchLabel: 'Search discounts',
    searchPlaceholder: 'Search by name or code',
    searchPlaceholderDiscovr: 'Search code, creator or campaign',
    statusTabs: 'Filter by status',
    all: 'All',
    allTypes: 'All types',
    allMethods: 'All methods',
    allCampaigns: 'All campaigns',
    campaignLabel: 'Campaign',
    status: { active: 'Active', scheduled: 'Scheduled', expired: 'Expired' },
    typeLabel: 'Type',
    type: {
      amount_off_products: 'Amount off products',
      amount_off_order: 'Amount off order',
      bxgy: 'Buy X get Y',
      free_shipping: 'Free shipping',
    },
    methodLabel: 'Method',
    method: { code: 'Code', automatic: 'Automatic' },
    clear: 'Clear filters',
  },
  typeValue: {
    buyXGetY: 'Buy X get Y',
    freeShipping: 'Free shipping',
    products: 'products',
    order: 'order',
    off: (amount: string, target: string) => `${amount} off ${target}`,
  },
  empty: 'No discounts in this store yet.',
  emptyDiscovr: 'No Discovr codes yet',
  emptyDiscovrBody: "Codes appear here after you generate them from a campaign's Shopify tab.",
  emptyFiltered: 'No discounts match these filters',
  emptyFilteredBody: 'Try a different term or clear the filters.',
  loadError: 'Couldn’t load your store discounts. Try again shortly.',
  retry: 'Try again',
  noneLoadedYet: 'No matches in the discounts loaded so far.',
  resultCount: (n: number, hasMore: boolean) => {
    if (hasMore) return `${n} shown`;
    return n === 1 ? '1 discount' : `${n} discounts`;
  },
  loadMore: 'Load more',
  loadingMore: 'Loading…',
};
